/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Teach.Wu
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _style = __webpack_require__(2);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	(function ($) {
	  if (!window.dataForGetClue) {
	    return;
	  }
	
	  var yuyueMatch = {
	    "托福": ["托福培训师", "托福考试"],
	    "雅思": ["雅思培训师", "雅思考试"],
	    "SAT": ["SAT培训师", "SAT考试"],
	    "GRE": ["GRE培训师", "GRE考试"],
	    "GMAT": ["GMAT培训师", "GMAT考试"],
	    "留学": ["留学申请专家", "留学申请"],
	    "activity": ["", ""]
	  };
	
	  var reg = {
	    phone: /^1\d{10}$/,
	    code: /^\d+$/
	  };
	
	  // const apiUrl = {
	  //   sms: dataForGetClue.smsUrl || '//i.service.zhan.test/api/common/sendSms',
	  //   saveClue: dataForGetClue.clueUrl || '//i.service.zhan.test/api/clue/first',
	  //   orderJijing: dataForGetClue.orderUrl || '//www.zhan.test/zapi/articles/mobilejijingsubscription.html',
	  //   downloadApiUrl: dataForGetClue.downloadApiUrl || '//www.zhan.test/zapi/articles/mobilejijingdownload.html'
	  // }
	  var apiUrl = {
	    sms: dataForGetClue.smsUrl || '//i.service.zhan.com/api/common/sendSmsGet', // '//i.service.zhan.com/api/common/sendSms',
	    saveClue: dataForGetClue.clueUrl || '//i.service.zhan.com/api/clue/first',
	    orderJijing: dataForGetClue.orderUrl || '//www.zhan.com/zapi/articles/mobilejijingsubscription.html',
	    downloadApiUrl: dataForGetClue.downloadApiUrl || '//www.zhan.com/zapi/articles/mobilejijingdownload.html'
	  };
	
	  var JijingComponent = function () {
	    function JijingComponent(params) {
	      _classCallCheck(this, JijingComponent);
	
	      var self = this;
	
	      this.params = params;
	
	      //if(params.jijingPage){
	      this.initCreate(this.params);
	      //}
	    }
	
	    _createClass(JijingComponent, [{
	      key: "initCreate",
	      value: function initCreate(params) {
	
	        if (params.jijingPage) {
	          this.pageType = "jijing";this.pageData = params.jijingPage;
	        }
	
	        this.isLogin = params.isLogin;
	
	        this.isGetPhone = params.isGetPhone;
	
	        this.container = document.createElement("div");
	
	        this.container.innerHTML = "";
	
	        this.container.setAttribute("id", "clueContainer");
	
	        this.totalCount = 60;
	
	        this.verifyCodeCount = null;
	
	        this.initState();
	      }
	    }, {
	      key: "initState",
	      value: function initState() {
	        var self = this;
	
	        this.state = { imgCodeUrl: "//i.service.zhan.com/api/common/getCaptcha" };
	
	        Object.defineProperty(self.state, "startDownload", {
	          set: function set(download) {
	            if (download) {
	              self.timeout(3000).then(function () {
	                window.open(self.pageData.downloadUrl);
	              });
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "phone", {
	          set: function set(phone) {
	            if (self.pageData.action != 'yuyue') return;
	            var clear = self.query('.input-clear')[0];
	            var getCodeBtn = self.query('.first-actionSms')[0];
	            if (phone.length > 0) {
	              clear.style.display = "block";
	              getCodeBtn.style.opacity = "1";
	            } else {
	              clear.style.display = "none";
	              getCodeBtn.style.opacity = "0.5";
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "code", {
	          set: function set(code) {
	            if (self.pageData.action != 'yuyue') return;
	            var clear = self.query('.input-clear-forcode')[0];
	            if (code.length > 0) {
	              clear.style.display = "block";
	            } else {
	              clear.style.display = "none";
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "showOverlay", {
	          set: function set(showOverlay) {
	            var overlay = self.container.querySelectorAll('.overlay')[0];
	            if (showOverlay) {
	              overlay.style.display = "block";
	            } else {
	              overlay.style.display = "none";
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "showLoginedPage", {
	          set: function set(showLoginedPage) {
	            var first = self.container.querySelectorAll('.jijing-first');
	            var unlogin = first[0];
	            var logined = first[1];
	            if (showLoginedPage) {
	              unlogin.style.display = "none";
	              logined.style.display = "block";
	            } else {
	              logined.style.display = "none";
	              unlogin.style.display = "block";
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "countRepeat", {
	
	          set: function set(countRepeat) {
	            var countDownWrap = self.container.querySelectorAll('.countDownWrap')[0],
	                countDownWrapRepeat = self.container.querySelectorAll('.countDownWrapRepeat')[0];
	            if (countRepeat) {
	              countDownWrap.style.display = "none";
	              countDownWrapRepeat.style.display = "block";
	              self.container.querySelectorAll('.backStep')[0].style.display = "block";
	            } else {
	              countDownWrap.style.display = "block";
	              countDownWrapRepeat.style.display = "none";
	              self.container.querySelectorAll('.backStep')[0].style.display = "none";
	            }
	          }
	        });
	
	        //首页倒计时
	
	        Object.defineProperty(self.state, "countStart", {
	
	          set: function set(countStart) {
	            var countDownWrap = self.container.querySelectorAll('.first-countDownWrap')[0],
	                actionSms = self.container.querySelectorAll('.first-actionSms')[0],
	                countDownWrapRepeat = self.container.querySelectorAll('.first-countDownWrapRepeat')[0];
	            if (countStart) {
	              countDownWrap.style.display = "none";
	              actionSms.style.display = "none";
	              countDownWrapRepeat.style.display = "block";
	            } else {
	              countDownWrap.style.display = "block";
	              countDownWrapRepeat.style.display = "none";
	              actionSms.style.display = "none";
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "showMsg", {
	          set: function set(showMsg) {
	            var msgoverlay = self.container.querySelectorAll('.msgoverlay')[0];
	            if (showMsg) {
	              msgoverlay.style.display = "block";
	            } else {
	              msgoverlay.style.display = "none";
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "page", {
	          set: function set(showPage) {
	            if (showPage == 1) {
	              self.pageType == "jijing" ? self.first.style.display = 'block' : self.first.style.display = 'block';
	
	              self.pageType == "jijing" ? self.state.showOverlay = false : self.state.showOverlay = true;
	
	              self.second.style.display = 'none';
	
	              self.countDown.innerHTML = "60";
	              self.totalCount = 60;
	              self.container.querySelectorAll('.backStep')[0].style.display = "none";
	            } else {
	              self.first.style.display = 'none';
	              self.second.style.display = 'block';
	              self.state.showOverlay = true;
	            }
	          }
	        });
	
	        Object.defineProperty(self.state, "showUI", {
	          set: function set(showUI) {
	            if (showUI) {
	              self.container.style.display = "block";
	            } else {
	              self.container.style.display = "none";
	            }
	          }
	        });
	      }
	    }, {
	      key: "handleDownload",
	      value: function handleDownload() {
	        //alert(222);
	        //return false;
	        var self = this;
	        var first = self.container.querySelectorAll('.page-first')[0],
	            second = self.container.querySelectorAll('.page-second')[0],
	            phone = self.container.querySelectorAll('.clue-input-phone')[0].value,
	            countDown = self.container.querySelectorAll('.countDown')[0];
	
	        var msg = "";
	
	        if (!reg.phone.test(phone)) msg = "请输入有效的手机号码";
	
	        if (self.pageData.action == "test") {
	          if (self.clueInputName.value.length == 0 || !self.clueInputName) msg = "请输入您的用户名";
	        }
	
	        if (msg) {
	          self.showMsg(msg);
	          return;
	        }
	
	        self.phone = phone;
	
	        self.state.countRepeat = false;
	
	        self.actionSms.removeEventListener('click', function () {
	          self.handleDownload();
	        }, false);
	
	        self.sendVerifyCode();
	      }
	    }, {
	      key: "handleSendMsg",
	      value: function handleSendMsg() {
	
	        var self = this;
	        if (self.firstActionSms.style["opacity"] != 1) return;
	        var phone = self.container.querySelectorAll('.clue-input-phone')[0].value;
	
	        var msg = "";
	
	        if (!reg.phone.test(phone)) msg = "请输入有效的手机号码";
	
	        if (msg) {
	          self.showMsg(msg);
	          return;
	        }
	
	        self.phone = phone;
	
	        self.firstActionSms.removeEventListener('click', function () {
	          self.handleSendMsg();
	        }, false);
	
	        //如果在倒计时中
	        if (self.totalCount != 60) {
	          self.showMsg("操作太频繁,请" + self.totalCount + "s后再试");
	          return;
	        }
	
	        this.firstClueInputCode.value = "";
	
	        this.ajaxSendMsg(self.query('.first-countDown')[0], "countStart", function (state) {
	          if (state == 1) {
	            self.state.countStart = false;
	          }
	        });
	      }
	    }, {
	      key: "handleFirstRegetSms",
	      value: function handleFirstRegetSms() {
	        var self = this;
	        var phone = self.query('.clue-input-phone')[0].value;
	        self.phone = phone;
	        if (!reg.phone.test(self.phone)) {
	          self.showMsg('请输入有效的手机号码');
	          return;
	        }
	
	        this.firstClueInputCode.value = "";
	        this.ajaxSendMsg(self.query('.first-countDown')[0], "countStart", function (state) {
	          if (state == 1) {
	            self.state.countStart = false;
	          }
	        });
	      }
	    }, {
	      key: "handleRegetSms",
	      value: function handleRegetSms() {
	        var self = this;
	
	        if (!reg.phone.test(self.phone)) {
	          self.showMsg('请输入有效的手机号码');
	          return;
	        }
	
	        self.state.countRepeat = false;
	
	        self.sendVerifyCode("true");
	      }
	    }, {
	      key: "handleFirstSubmitAction",
	      value: function handleFirstSubmitAction() {
	        var self = this;
	        if (this.actionFirstSubmit.style.opacity != 1) return;
	        self.actionFirstSubmit.style.opacity = "0.5";
	        var verifyCode = this.firstClueInputCode.value;
	        var phone = self.query('.clue-input-phone')[0].value;
	        var msg = "";
	        if (!reg.code.test(verifyCode)) {
	          msg = "请输入有效的验证码";
	        }
	        if (!reg.phone.test(phone)) {
	          msg = "请输入有效的手机号码";
	        }
	        if (msg) {
	          self.showMsg(msg);
	          self.actionFirstSubmit.style.opacity = "1";
	          return;
	        }
	        self.phone = phone;
	        var params = {
	          phone: self.phone,
	          phone_code: verifyCode,
	          source: '机经',
	          type: 2,
	          clue_str: self.clue_str
	        };
	
	        $.ajax({
	          url: apiUrl.saveClue,
	          type: 'GET',
	          dataType: 'jsonp',
	          jsonp: 'callback',
	          jsonpCallback: "apicallback",
	          data: params,
	          success: function success(data) {
	            if (data.status == 1) {
	
	              self.showMsg("预约成功");
	              self.timeout(2000).then(function () {
	                self.state.showUI = false;
	                self.handleClueMsgBoxClose();
	              });
	              self.succseeFinal();
	            } else {
	              self.showMsg('操作失败\n' + data.message);
	            }
	            self.actionFirstSubmit.style.opacity = "1";
	          },
	          error: function error() {
	            self.showMsg('服务异常，请稍后再试');
	            self.actionFirstSubmit.style.opacity = "1";
	          }
	        });
	      }
	    }, {
	      key: "handleSubmitAction",
	      value: function handleSubmitAction() {
	        var self = this;
	
	        if (self.isClick == true) return;
	        self.isClick = true;
	        self.submitAction.style.backgroundColor = "rgba(255, 102, 0, 0.6)";
	        var verifyCode = this.clueInputCode.value;
	
	        if (!reg.code.test(verifyCode)) {
	          self.showMsg('请输入有效的验证码');
	          self.submitAction.style.backgroundColor = "#ff6600";
	          self.isClick = false;
	          return;
	        }
	
	        var params = {
	          phone: self.phone,
	          phone_code: verifyCode,
	          source: '机经',
	          type: 2,
	          clue_str: self.clue_str
	        };
	
	        var startDownload = false;
	
	        var handleSuccess = function handleSuccess() {
	
	          // 1：机经下载  
	          if (self.pageData.action == 'download') {
	            //关闭浮层
	            self.downloadJijing();
	            self.state.page = 1;
	            self.state.showLoginedPage = true;
	          } else if (self.pageData.action == 'order') {
	            // 2: 机经订阅
	            // 订阅具体机经文章，调用订阅接口
	            var handleInnerSuccess = function handleInnerSuccess() {
	              // 订阅成功, 更新订阅数
	              // 记录已订阅状态
	              var itemKey = 'orderedArticle' + self.pageData.articleId;
	              //window.localStorage.setItem(itemKey, 'true');
	              $.cookie(itemKey, 'true', { expires: 1, path: '/' });
	              self.showMsg('订阅成功');
	              self.addCount(".ordercount");
	              self.timeout(2000).then(function () {
	                self.state.showUI = false;
	              });
	            };
	
	            var ajaxOrder = $.ajax({
	              url: apiUrl.orderJijing,
	              type: 'post',
	              cache: false,
	              dataType: 'json',
	              asyns: false,
	              data: {
	                "articleId": self.pageData.articleId
	              },
	              success: function success(data) {
	                if (data.status == "success") {
	                  handleInnerSuccess();
	                } else {
	                  self.showMsg('订阅失败，请稍后再试');
	                }
	                self.isClick = false;
	                self.submitAction.style.backgroundColor = "#ff6600";
	              },
	              error: function error(data) {
	                self.showMsg('订阅服务异常，请稍后再试');
	                self.isClick = false;
	                self.submitAction.style.backgroundColor = "#ff6600";
	              }
	            });
	          } else if (self.pageData.action == 'yuyue' || self.pageData.action == 'test' || self.pageData.action == 'contact') {
	            //3:预约&测试
	            self.showMsg(self.pageData.action == 'yuyue' || self.pageData.action == 'contact' ? "预约成功" : "申请成功");
	            self.isClick = false;
	            self.timeout(2000).then(function () {
	              self.state.page = 1;
	              self.state.showUI = false;
	              self.handleClueMsgBoxClose();
	            });
	          } else if (self.pageData.action == 'appDownload') {
	
	            //3:app下载
	            self.isClick = false;
	            setTimeout(function () {
	              self.state.page = 1;
	              self.state.showUI = false;
	              self.handleClueMsgBoxClose();
	              window.location.href = self.pageData.url;
	            }, 500);
	          }
	
	          self.succseeFinal();
	        };
	
	        $.ajax({
	          url: apiUrl.saveClue,
	          type: 'GET',
	          dataType: 'jsonp',
	          jsonp: 'callback',
	          jsonpCallback: "apicallback",
	          data: params,
	          success: function success(data) {
	            if (data.status == 1) {
	              if (self.pageData.action == 'download') {
	                startDownload = true;
	              } else {
	                clearInterval(self.checkLoad);
	              };
	              handleSuccess();
	            } else {
	              self.showMsg('操作失败\n' + data.message);
	            }
	            self.isClick = false;
	            self.submitAction.style.backgroundColor = "#ff6600";
	          },
	          error: function error() {
	            self.showMsg('服务异常，请稍后再试');
	            self.isClick = false;
	            self.submitAction.style.backgroundColor = "#ff6600";
	          }
	        });
	
	        self.checkLoad = setInterval(function () {
	          if (startDownload) {
	            window.location.href = self.pageData.downloadUrl;
	            clearInterval(self.checkLoad);
	          }
	        }, 1000);
	      }
	    }, {
	      key: "succseeFinal",
	      value: function succseeFinal() {
	        var signStatus = self.isLogin ? 'Signed On' : 'Signed Off';
	        //window.localStorage.setItem("isGetPhone",'true');
	        $.cookie('isGetPhone', 'true', { expires: 1, path: '/' });
	        window.ga('send', 'event', 'xkzhongduan', window.location.href, signStatus);
	      }
	    }, {
	      key: "handleSubmitActionForDirect",
	      value: function handleSubmitActionForDirect() {
	        var self = this;
	        if (self.pageData.action == 'download') {
	          self.downloadJijing();
	          window.open(self.pageData.downloadUrl);
	        } else if (self.pageData.action == 'order') {
	          // 订阅具体机经文章，调用订阅接口
	          self.orderJijing();
	        }
	      }
	    }, {
	      key: "orderJijing",
	      value: function orderJijing() {
	        var self = this;
	        var handleInnerSuccess = function handleInnerSuccess() {
	          // 订阅成功, 更新订阅数
	          // 记录已订阅状态
	          var itemKey = 'orderedArticle' + self.pageData.articleId;
	          //window.localStorage.setItem(itemKey, 'true');
	          $.cookie(itemKey, 'true', { expires: 1, path: '/' });
	          self.showMsg('订阅成功');
	          self.addCount(".ordercount");
	          self.timeout(2000).then(function () {
	            self.state.showUI = false;
	          });
	        };
	
	        var ajaxOrder = $.ajax({
	          url: apiUrl.orderJijing,
	          type: 'post',
	          cache: false,
	          dataType: 'json',
	          data: {
	            "articleId": self.pageData.articleId
	          },
	          success: function success(data) {
	            if (data.status == "success") {
	              handleInnerSuccess();
	            } else {
	              self.showMsg('订阅失败，请稍后再试');
	            }
	          },
	          error: function error(data) {
	            self.showMsg('订阅服务异常，请稍后再试');
	          }
	        });
	      }
	    }, {
	      key: "startVCodeCounter",
	      value: function startVCodeCounter(isRepeat) {
	        var self = this;
	
	        //如果在倒计时中
	        if (self.totalCount != 60) {
	          self.showMsg("操作太频繁,请" + self.totalCount + "s后再试");
	          return;
	        }
	
	        if (isRepeat == "false") self.state.page = 2;
	      }
	    }, {
	      key: "ajaxSendMsg",
	      value: function ajaxSendMsg(el, state, callback) {
	        var self = this;
	        if (self.getImgCode() == "") {
	          self.showMsg('请输入图形验证码');
	          return false;
	        }
	
	        clearInterval(self.verifyCodeCount);
	
	        self.verifyCodeCount = setInterval(function () {
	          var time = self.totalCount - 1;
	          self.totalCount = time;
	          el.innerHTML = time;
	          if (time == 0) {
	            self.clearVerifyCodeCount(el, state);
	          }
	        }, 1000);
	        $.ajax({
	          url: apiUrl.sms,
	          type: 'get',
	          cache: false,
	          dataType: 'jsonp',
	          jsonp: 'callback',
	          data: {
	            "phone": self.phone,
	            "type": 10,
	            "yzm": self.getImgCode()
	          },
	          success: function success(data) {
	            if (data.status != 1) {
	              self.showMsg(data.message);
	              self.clearVerifyCodeCount(el, state);
	            }
	            //self.reGetImg();
	            if (callback !== undefined) {
	              callback(data.status);
	            }
	          },
	          error: function error(data) {
	            self.showMsg('发送验证码服务异常，请稍后再试');
	          }
	        });
	      }
	    }, {
	      key: "clearVerifyCodeCount",
	      value: function clearVerifyCodeCount(el, state) {
	        var self = this;
	        el.innerHTML = "60";
	        self.totalCount = 60;
	        this.state[state] = true;
	        clearInterval(self.verifyCodeCount);
	      }
	
	      // 发送验证码
	
	    }, {
	      key: "sendVerifyCode",
	      value: function sendVerifyCode() {
	        var isRepeat = arguments.length <= 0 || arguments[0] === undefined ? "false" : arguments[0];
	
	
	        var self = this;
	        this.clueInputCode.value = "";
	
	        this.ajaxSendMsg(self.countDown, "countRepeat", function (state) {
	          if (state == 1) {
	            self.startVCodeCounter(isRepeat);
	          }
	        });
	      }
	    }, {
	      key: "openWindow",
	      value: function openWindow(owurl) {
	        var astr = "<a href='" + owurl + "' target='_blank'></a>";
	        if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.match(/8./i) == "8.") {
	          window.open(owurl);
	        } else {
	          var a = $(astr).get(0);
	          var e = document.createEvent('MouseEvents');
	          e.initEvent('click', true, true);
	          a.dispatchEvent(e);
	        }
	      }
	    }, {
	      key: "handleHideUI",
	      value: function handleHideUI() {
	        if (this.pageData.action == "order" || this.pageData.action == "download") {
	          this.handleBackStep();
	          return;
	        }
	        var self = this;
	        self.state.showUI = false;
	        self.handleClueMsgBoxClose();
	      }
	    }, {
	      key: "handleBackStep",
	      value: function handleBackStep() {
	        this.state.page = 1;
	      }
	    }, {
	      key: "showMsg",
	      value: function showMsg(msg) {
	        this.clueMsgBoxContent.innerHTML = msg;
	        this.state.showMsg = true;
	      }
	    }, {
	      key: "handleClueMsgBoxClose",
	      value: function handleClueMsgBoxClose() {
	        this.state.showMsg = false;
	      }
	    }, {
	      key: "timeout",
	      value: function timeout(ms) {
	        return new Promise(function (resolve) {
	          setTimeout(resolve, ms, "done");
	        });
	      }
	    }, {
	      key: "addCount",
	      value: function addCount(classNmae) {
	        var count = parseInt($(classNmae).text()) + 1;
	        $(classNmae).text(count);
	        this.clueCountF.innerHTML = this.clueCountS.innerHTML = count;
	      }
	
	      // 机经下载
	
	    }, {
	      key: "downloadJijing",
	      value: function downloadJijing() {
	        var self = this;
	        $.post(apiUrl.downloadApiUrl, {
	          downloadId: self.pageData.downloadId
	        }).done(function (data) {
	          if (data.status != "success") {
	            self.showMsg('下载失败，请稍后再试');
	          } else {
	            self.addCount(".downloadcount");
	          }
	        }).fail(function () {
	          self.showMsg('服务异常，请稍后再试');
	        });
	      }
	    }, {
	      key: "handleSelectFocus",
	      value: function handleSelectFocus(e) {
	        if (e.target && e.target.nodeName != "SPAN") return;
	        var clueFocus = this.query('.clue-focus')[0];
	        var cArray = clueFocus.children;
	
	        for (var i = 0; i < cArray.length; i++) {
	          cArray[i].className = "";
	        }
	
	        e.target.className = "hotFocus";
	      }
	    }, {
	      key: "initPage",
	      value: function initPage() {
	        this.state.page = 1;
	
	        this.clue_str = "";
	
	        if (this.pageData.action == 'order') this.clue_str = window.jijingSubscriptionSource || "";
	
	        if (this.pageData.action == 'download') this.clue_str = window.jijingDownloadSource || "";
	
	        if (this.pageData.action == 'yuyue') this.clue_str = window.consultationSource || "";
	
	        if (this.pageData.action == 'contact') this.clue_str = window.contactSource || "";
	
	        if (this.pageData.action == 'test') this.clue_str = window.testingSource || "";
	
	        if (this.pageData.clue_str) this.clue_str = this.pageData.clue_str;
	
	        var isGetPhoneLocal = $.cookie("isGetPhone");
	
	        if (this.pageType == "jijing") {
	          if (this.pageData.action == "download") {
	            if (this.isLogin && this.isGetPhone == true || isGetPhoneLocal == "true") {
	              this.state.showLoginedPage = true;
	            } else {
	              this.state.showLoginedPage = false;
	            }
	
	            this.clueCountF.innerHTML = this.clueCountS.innerHTML = $(".downloadcount").text();
	          } else {
	            if (this.isLogin && this.isGetPhone == true && isGetPhoneLocal == "true") {
	              this.state.showLoginedPage = true;
	            } else {
	              this.state.showLoginedPage = false;
	            }
	
	            this.clueCountF.innerHTML = this.clueCountS.innerHTML = $(".ordercount").text();
	          }
	        } else {
	          //预约界面，初始隐藏
	          this.state.showUI = false;
	        }
	      }
	    }, {
	      key: "query",
	      value: function query(select) {
	        return this.container.querySelectorAll(select);
	      }
	    }, {
	      key: "bindClick",
	      value: function bindClick(el, callback) {
	        var _this = this;
	
	        var self = this;
	        el ? el.addEventListener('click', function () {
	          callback.apply(_this);
	        }, false) : null;
	      }
	    }, {
	      key: "unbindClick",
	      value: function unbindClick(el, callback) {
	        var _this2 = this;
	
	        var self = this;
	        el ? el.removeEventListener('click', function () {
	          callback.apply(_this2);
	        }, false) : null;
	      }
	    }, {
	      key: "reGetImg",
	      value: function reGetImg() {
	        this.imgCodeEl = this.query('.imgCode')[0];
	        $(this.imgCodeEl).attr("src", this.state.imgCodeUrl + "?" + Math.random());
	      }
	    }, {
	      key: "getImgCode",
	      value: function getImgCode() {
	        return this.imgCodeInputEl.value;
	      }
	    }, {
	      key: "initEvent",
	      value: function initEvent() {
	        var self = this;
	
	        var countDownWrapRepeat = this.query('.countDownWrapRepeat')[0],
	            clueMsgBoxClose = this.query('.clue-msg-box-close')[0],
	            msgoverlay = this.query('.msgoverlay')[0],
	            clueFocus = this.query('.clue-focus')[0],
	            backStep = this.query('.backStep')[0];
	
	        this.firstCountDownWrapRepeat = this.query('.first-countDownWrapRepeat')[0];
	
	        this.submitAction = this.query('.submitAction')[0];
	
	        this.actionFirstSubmit = this.query('.actionFirstSubmit')[0];
	
	        this.submitActionForDirect = this.query('.submitActionForDirect')[0];
	
	        this.clueMsgBoxContent = this.query('.clue-msg-box-content')[0];
	
	        this.clueCountF = this.query('.clue-count')[0];
	        this.clueCountS = this.query('.clue-count')[1];
	
	        this.clueInputCode = this.query('.clue-input-code')[0];
	        this.firstClueInputCode = this.query('.first-input-code')[0];
	        this.clueInputName = this.query('.clue-input-name')[0];
	
	        this.clueOverlay = this.query('.clue-overlay')[0];
	
	        this.actionSms = this.query('.actionSms')[0];
	
	        this.firstActionSms = this.query('.first-actionSms')[0];
	
	        this.first = self.container.querySelectorAll('.page-first')[0];
	
	        this.second = self.container.querySelectorAll('.page-second')[0];
	
	        this.countDown = self.container.querySelectorAll('.countDown')[0];
	
	        this.cancelBtn = this.query('.cancel-btn')[0];
	
	        this.imgCodeEl = this.query('.imgCode')[0];
	        this.imgCodeInputEl = this.query('.imgCodeInput')[0];
	        this.clueOverlay ? this.clueOverlay.addEventListener('click', function () {
	          self.handleHideUI();
	        }, false) : null;
	
	        this.bindClick(this.cancelBtn, self.handleHideUI);
	
	        this.bindClick(this.actionSms, self.handleDownload);
	
	        this.bindClick(this.firstActionSms, self.handleSendMsg);
	
	        this.bindClick(this.firstCountDownWrapRepeat, self.handleFirstRegetSms);
	
	        countDownWrapRepeat ? countDownWrapRepeat.addEventListener('click', function () {
	          self.handleRegetSms();
	        }, false) : null;
	
	        this.submitAction ? this.submitAction.addEventListener('click', function () {
	          self.handleSubmitAction();
	        }, false) : null;
	
	        this.bindClick(this.actionFirstSubmit, self.handleFirstSubmitAction);
	
	        this.submitActionForDirect ? this.submitActionForDirect.addEventListener('click', function () {
	          self.handleSubmitActionForDirect();
	        }, false) : null;
	
	        this.bindClick(this.imgCodeEl, self.reGetImg);
	
	        msgoverlay ? msgoverlay.addEventListener('click', function (e) {
	          e.target.nodeName == "DIV" ? self.handleClueMsgBoxClose() : null;
	        }, false) : null;
	
	        clueMsgBoxClose ? clueMsgBoxClose.addEventListener('click', function () {
	          self.handleClueMsgBoxClose();
	        }, false) : null;
	
	        clueFocus ? clueFocus.addEventListener('click', function (e) {
	          self.handleSelectFocus(e);
	        }, false) : null;
	
	        backStep ? backStep.addEventListener('click', function () {
	          self.handleBackStep();
	        }, false) : null;
	
	        //点击链接订阅框focus，弹出手机键盘
	        $(".getClueByOrderForClick").click(function () {
	          $(".clue-input-phone").focus();
	        });
	
	        $(".first-clue-input-phone").bind("keyup", function () {
	          self.state.phone = $(this).val();
	          self.actionFirstSubmit.style.opacity = $(this).val() > 0 && $(".first-input-code").val().length > 0 ? "1" : "0.5";
	        });
	
	        $(".first-input-code").bind("keyup", function () {
	          self.state.code = $(this).val();
	          self.actionFirstSubmit.style.opacity = $(this).val() > 0 && $(".clue-input-phone").val().length > 0 ? "1" : "0.5";
	        });
	
	        $(".input-clear-forphone").click(function () {
	          $(this).parent().find("input").val("");
	          self.state.phone = "";
	          $(".input-clear-forphone").hide();
	        });
	
	        $(".input-clear-forcode").click(function () {
	          $(this).parent().find("input").val("");
	          self.state.code = "";
	          $(".input-clear-forcode").hide();
	        });
	
	        $(function () {
	          $(".foot").css("padding-bottom", "40px");
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	
	        var self = this;
	
	        function getFocus() {
	          var focus = "";
	          self.pageData.focus.map(function (c) {
	            focus += "<span>" + c + "</span>";
	          });
	          return focus;
	        }
	
	        var finishBtnText = "完成订阅";
	
	        if (this.pageData.action == "test") finishBtnText = "完成测试预约";
	        if (this.pageData.action == "download") finishBtnText = "完成下载";
	        if (this.pageData.action == "yuyue" || this.pageData.action == "contact") finishBtnText = "完成预约";
	
	        this.pageData.finishBtnTitle ? finishBtnText = this.pageData.finishBtnTitle : null;
	
	        var yuyuehead, yuyuetitle, yuyuebtn;
	
	        var first = self.pageType == "jijing" ? "<div class=\"jijing-first page-first\">\n                    <div>\n                        <section class='jijing-input-wrap'>\n                          <input class='clue-input clue-input-phone' placeholder='填写您的手机号' type=\"tel\"/>\n                        </section>\n\n                        <section class='jijing-info-wrap'>\n                          <span class='clue-count'>0</span>\n                          <span>" + (this.pageData.action == "download" ? "次已下载" : "人已订阅") + "</span>\n                        </section>\n\n                        <section>                        \n                          <button class='clue-btn actionSms'>\n                            <span class=" + (this.pageData.action == "download" ? "icon-xuanfu_xiazai" : "") + "></span>\n                            立即" + (this.pageData.action == "download" ? "下载" : "订阅") + "</button>\n                        </section>\n                    </div>\n                    <div>\n                     <section style=\"padding-top:0px;width:100%; margin-left:10px\">\n                        <input class=\"clue-input  imgCodeInput\" style=\"margin-top:0px;width:45%\" placeholder='请输入图形验证码' />\n                        <span class=\"input-clear input-clear-forcode\"></span> \n                       \n                        <a style=\"vertical-align:middle; display:inline-block\"><img style=\"width:55%\" class=\"imgCode\"  src=\"//i.service.zhan.com/api/common/getCaptcha\"></a>\n                      \n                      </section>\n                    </div>\n</div>\n\n\n                    <div class=\"jijing-first\">\n                        <section class='jijing-logined-wrap'>\n                          本期机经快速" + (this.pageData.action == "download" ? "下载" : "订阅") + "通道\n                        </section>\n                        <section class='jijing-info-wrap'>\n                          <span class='clue-count'>0</span>\n                          <span>" + (this.pageData.action == "download" ? "次已下载" : "人已订阅") + "</span>\n                        </section>\n                        <section>\n                          \n                          <button class='clue-btn submitActionForDirect'><span class=" + (this.pageData.action == "download" ? "icon-xuanfu_xiazai" : "") + "></span>立即" + (this.pageData.action == "download" ? "下载" : "订阅") + "</button>\n                        </section>\n                    </div>\n                  " : (yuyuehead = this.pageData.action == "yuyue" ? "我对" + yuyueMatch[this.pageData.type][1] + "有疑问，请老师尽快回电！" : "为确保录取几率的客观真实，小站留学顾问将联系您进行一对一定制分析。", yuyuehead = this.pageData.action == "contact" ? "请留下您的联系方式，小站老师将会尽快与您取得联系" : yuyuehead,
	        //直接取headIntroText
	        this.pageData.headIntroText ? yuyuehead = this.pageData.headIntroText : null, yuyuetitle = this.pageData.action == "yuyue" ? "预约" + yuyueMatch[this.pageData.type][0] + "答疑解惑" : "测试录取几率",
	        //活动弹窗
	        yuyuetitle = this.pageData.action == "contact" ? "联系老师" : yuyuetitle,
	        //直接取title中的值
	        this.pageData.title ? yuyuetitle = this.pageData.title : null, yuyuebtn = this.pageData.action == "yuyue" || this.pageData.action == "contact" ? "立即预约" : "申请测试",
	        //直接取btnTitle中的值
	        this.pageData.btnTitle ? yuyuebtn = this.pageData.btnTitle : null, "<div class=\"yuyue-first page-first\">\n                    <header class='yuyue-first-title'>\n                      <span>" + yuyuetitle + "</span><span class=\"cancel-btn\">取消</span></header>\n                    <section class='yuyue-first-inner-wrap'>\n                      <header>" + yuyuehead + "</header>\n\n                      <section style=" + (this.pageData.action == "yuyue" || this.pageData.action == "contact" || this.pageData.action == "appDownload" ? "display:none" : "display:block;") + ">\n                        <input class='clue-input clue-input-name' placeholder='请输入您的姓名' type=\"text\"/>\n                      </section>\n\n                      <section style=" + (this.pageData.action == "yuyue" ? "" : "display:block;") + ">\n                        <input class='clue-input first-clue-input-phone clue-input-phone' placeholder='请输入您的联系电话' type=\"tel\"/>\n                        <span class=\"input-clear input-clear-forphone\"></span>\n                      </section>\n\n\n                      <section >\n                        <input class=\"clue-input  imgCodeInput\" style=\"margin-top:0px;width:45%\" placeholder='请输入图形验证码' />\n                        <span class=\"input-clear input-clear-forcode\"></span> \n                       \n                          <a style=\"display:inline-block;padding-top:5px\"><img class=\"imgCode\" style=\"width:55%\"   src=\"//i.service.zhan.com/api/common/getCaptcha\"></a>\n                       \n                      </section>\n\n                      <section style=" + (this.pageData.action == "yuyue" ? "display:block;" : "display:none;") + ">\n                        <input class=\"clue-input first-input-code\" style=\"width:45%;margin-top:10px\" placeholder='请输入短信验证码' type=\"tel\"/>\n                        <span class=\"input-clear input-clear-forcode\"></span>\n                        <div style=\"padding-top:15px;\">\n                          <section class=\"first-actionSms\">获取验证码</section>\n                          <section class=\"first-countDownWrap\"><span class=\"first-countDown\">60</span>s后重新获取验证码</section>\n                          <section class=\"first-countDownWrapRepeat\">重新获取</section>\n                        </div>\n                      </section>\n\n                    </section>\n                    <footer style=" + (this.pageData.action == "yuyue" ? "display:none" : "display:block") + ">\n                      <header style=" + (this.pageData.action == "contact" ? "display:block" : "display:none") + ">关注热点:</header>\n                      <section class=\"clue-focus\" style=" + (this.pageData.action == "contact" ? "display:block" : "display:none") + ">\n                        " + (this.pageData.action == "contact" ? getFocus() : '') + "\n                      </section>\n                      <button class='clue-btn actionSms'>" + yuyuebtn + "</button>\n                    </footer>\n                    <footer style=" + (this.pageData.action == "yuyue" ? "display:block" : "display:none") + ">\n                      <button class='clue-btn actionFirstSubmit'>" + yuyuebtn + "</button>\n                    </footer>\n                 </div>\n                ");
	
	        var headIntroText = "小站会员专属特权 订阅机经后第一时间获取更新通知";
	        var secondPagehead = this.pageType == "jijing" ? this.pageData.action == "download" ? self.pageData.type + "机经下载" : self.pageData.type + "机经订阅" : this.pageData.action == "yuyue" ? "预约咨询" : "测试录取几率";
	        secondPagehead = this.pageData.action == "contact" ? "联系老师" : secondPagehead;
	
	        if (this.pageData.action == "test") headIntroText = "为确保录取几率的客观真实，小站留学顾问将联系您进行一对一定制分析。";
	
	        if (this.pageData.action == "download") headIntroText = "小站会员专属特权 本期机经完整版免费下载。";
	
	        if (this.pageData.action == "yuyue") headIntroText = this.pageData.subject + "有难题？留下您的联系方式，小站" + this.pageData.type + "专家1对1为您解答。";
	
	        if (this.pageData.action == "contact") headIntroText = "请留下您的联系方式，小站老师将会尽快与您取得联系";
	
	        //直接取headIntroText
	        this.pageData.title ? secondPagehead = this.pageData.title : null;
	        //直接取headIntroText
	        this.pageData.headIntroText ? headIntroText = this.pageData.headIntroText : null;
	
	        var jijingUI = _style2["default"] + "\n            <div class=\"overlay clue-overlay\" id=\"clue-overlay\" style=" + (this.pageType == "jijing" ? "display:none" : "display:block") + "></div>\n            <div class=\"msgoverlay\">\n                  <div class=\"clue-msg-box\">\n                    <section class=\"clue-msg-box-content\">请输入正确的11位手机号！</section>\n                    <footer><span class=\"clue-msg-box-close\">确定</span></footer>\n                  </div>\n                </div>\n            <div class='clue-container'>\n              <div class='jijing-container' id=\"jijing-container\">\n\n                " + first + "\n\n                <div class=\"page-second page-second-style\">\n                    <header class='second-title'>\n                      <span>" + secondPagehead + "</span><span class=\"backStep\">返回上一步</span></header>\n                    <section class='second-inner-wrap'>\n                      <header>\n                      " + headIntroText + "</header>\n                      <section>\n                        <input id=\"tsphone\" class='clue-input clue-input-code' placeholder='请输入短信验证码' type=\"tel\"/>\n                        <div>\n                          <section class=\"countDownWrap\"><span class=\"countDown\">60</span>s后重新获取验证码</section>\n                          <section class=\"countDownWrapRepeat\">重新获取</section>\n                        </div>\n                      </section>\n                    </section>\n                    <footer>\n                      <button class='clue-btn submitAction'><span class=\"icon-btn_ok\"></span>\n                        " + finishBtnText + "\n                      </button>\n                    </footer>\n                </div>\n              </div>\n            </div>\n          ";
	        this.container.innerHTML = "";
	        this.container.innerHTML = jijingUI;
	
	        if (self.pageData) {
	          var action = self.pageData.action;
	          var itemKey = 'orderedArticle' + self.pageData.articleId;
	
	          //联系我,预约,下载,未订阅过该机经的显示
	          if (action == 'test' || action == 'appDownload' || action == 'yuyue' || action == 'download' || action == 'contact' || action == 'order' && $.cookie(itemKey) != "true") {
	            document.body.appendChild(this.container);
	          }
	        }
	
	        this.initEvent();
	
	        this.initPage();
	      }
	    }]);
	
	    return JijingComponent;
	  }();
	
	  var getClue = new JijingComponent(dataForGetClue);
	
	  if (window.dataForGetClue.jijingPage) getClue.render();
	
	  $('.getClueByYuyue').click(function () {
	    getClue.pageType = "yuyue";
	    getClue.pageData = getClue.params.yuyuePage.yuyue;
	
	    getClue.render();
	    getClue.state.showUI = true;
	  });
	
	  $('.getClueByActivity').click(function () {
	    // var clearBodyScroll;
	    // if(clearBodyScroll){
	    //   clearInterval(clearBodyScroll);
	    // }
	    getClue.pageType = "yuyue";
	    getClue.pageData = getClue.params.yuyuePage.activity;
	
	    getClue.render();
	    getClue.state.showUI = true;
	
	    //fix ios fixed layout bug
	    // var bodyClass=document.body.className;
	
	    // document.body.className="bodyNOScroll "+bodyClass;
	    // document.body.style.height=window.innerHeight+"px";
	    // var clueContainer=document.getElementById("clueContainer");
	    // clearBodyScroll=setInterval(function(){
	    //   if(clueContainer.style.display=="none"){
	    //     clearInterval(clearBodyScroll);
	
	    //     var bodyClass=document.body.className;
	    //     bodyClass=bodyClass.replace(/bodyNOScroll /g, "");
	
	    //     document.body.className=bodyClass;
	    //     document.body.style.height="auto";
	    //   }
	    // },500);
	  });
	
	  $('.getClueByContact').click(function () {
	    getClue.pageType = "contact";
	    getClue.pageData = getClue.params.contactPage.contact;
	
	    getClue.render();
	    getClue.state.showUI = true;
	  });
	
	  //论坛app下载
	  $('.getClueByAppDownload').click(function () {
	    var key = $(this).attr("key");
	    var initdata = getClue.params[key].initdata;
	    getClue.pageType = initdata.action;
	    getClue.pageData = initdata;
	    //用户已登录
	    if (window.dataForGetClue.isLogin || window.dataForGetClue.isGetPhone || $.cookie("isGetPhone") == "true") {
	      window.location.href = initdata.url;
	    } else {
	      getClue.render();
	      getClue.state.showUI = true;
	    }
	  });
	
	  $('.getClueByTest').click(function () {
	
	    getClue.pageType = "yuyue";
	    getClue.pageData = getClue.params.yuyuePage.test;
	    getClue.render();
	    getClue.state.showUI = true;
	  });
	})(jQuery);

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	var colorOrange = "#ff6600",
	    color333 = "#333333";
	var Style = "\n    <style>\n    .clue-container *{\n      box-sizing:border-box;\n    }\n    .clue-container{\n      background-color:#efefef;\n      position:fixed;\n      bottom:0px;\n      left:0px;\n      width:100%;\n      z-index:1112;\n      font-family:\"Microsoft YaHei\";\n    }\n    .jijing-container{\n      position:relative;\n      width:100%;\n      border-top:1px solid #eaeaea;\n    }\n    .page-first{\n      position:relative;\n      z-index:10000;\n      background-color:#f0f0f0;\n    }\n    .jijing-first{\n      display:block;\n      //display:-webkit-flex;\n      justify-content:space-between;\n      align-items: center;\n      width:100%;\n      height:40px;\n    }\n    .jijing-first section:nth-child(1){\n      //-webkit-flex-basis:340px;\n      //flex-basis:340px;\n      float:left;\n      width:49.6875%;\n    }\n    .jijing-first section:nth-child(1) input{\n     margin-top:5px; \n     height:30px;\n    }\n    .jijing-first section:nth-child(2){\n      text-align:center;\n      //-webkit-flex-basis:110px;\n      //flex-basis:110px;\n      float:left;\n      width:20%;\n    }\n    .jijing-first section:nth-child(3){\n      //-webkit-flex-basis:190px;\n      //flex-basis:190px;\n      float:left;\n      width: 30%;\n    }\n    .page-second{\n      position:relative;\n      z-index:10000;\n      background-color:#f0f0f0;\n      display:none;\n    }\n    .overlay{\n      content:\"\";\n      z-index:999;\n      width:100%;\n      height:100%;\n      position:fixed;\n      top:0px;\n      left:0px;\n      display:none;\n      background:rgba(0,0,0,0.4);\n    }\n    .msgoverlay{\n      content:\"\";\n      z-index:99999;\n      width:100%;\n      height:100%;\n      position:fixed;\n      top:0px;\n      left:0px;\n      display:none;\n      background:rgba(0,0,0,0.4);\n    }\n    .clue-msg-box{\n      border-radius:6px;\n      background:#fff;\n      margin:50% auto 0 auto;\n      width:80%;\n      color:" + color333 + ";\n      font-size:15px;\n    }\n    .clue-msg-box section{\n      padding:25px;\n      border-bottom:1px solid #d9d9d9;\n    }\n    .clue-msg-box footer{\n      text-align:center;\n      color:" + colorOrange + ";\n      font-size:17px;\n      padding:14px 0px;\n    }\n    .clue-msg-box footer span{\n      display:block;\n      width:100%;\n    }\n    .jijing-input-wrap{\n      padding-left:10px;\n    }\n    .jijing-logined-wrap{\n      background:#fff;\n      color:#ff6600;\n      font-size:15px;\n      height:100%;\n      line-height:40px;\n      padding:0px 10px;\n    }\n    .jijing-logined-wrap section:nth-child(1){\n      -webkit-flex-basis:340px;\n      flex-basis:340px;\n    }\n    .jijing-logined-wrap section:nth-child(2){\n      -webkit-flex-basis:110px;\n      flex-basis:110px;\n    }\n    .jijing-logined-wrap section:nth-child(3){\n      -webkit-flex-basis:190px;\n      flex-basis:190px;\n    }\n    .clue-input{\n      width:100%;\n      height:40px;\n      font-size:14px;\n      color:#999999;\n      border-radius:6px;\n      border:1px solid rgba(0,0,0,0.1);\n      padding-left:10px;\n    }\n    .clue-input:focus{\n      border:1px solid rgba(0,0,0,0.3);\n      outline:none;\n    }\n    .clue-btn{\n      width:100%;\n      height:40px;\n      background-color:" + colorOrange + ";\n      font-size:15px;\n      color:#fff;\n      outline:none;\n      border-top-left-radius:6px;\n      border-bottom-left-radius:6px;\n      border:0px solid #fff;\n    }\n    .jijing-info-wrap{\n      font-size:11px;\n      color:" + color333 + ";\n      width: 48px;\n    }\n    .jijing-info-wrap .clue-count{\n      display:block;\n      width:100%;\n      font-size:15px;\n      text-align:center;\n      color:" + colorOrange + ";\n    }\n\n    .second-title,.yuyue-first-title{\n      display:flex;\n      justify-content:center;\n      align-items:center;\n      height:46.5px;\n      border-bottom:1px solid #cccccc;\n      font-size:18px;\n      color:" + color333 + ";\n      text-align:center;\n    }\n    .backStep{\n      position:absolute;\n      top:14px;\n      right:10px;\n      color:#b4b4b4;\n      font-size:12px;\n      display:none;\n    }\n    .yuyue-first-inner-wrap{\n      padding:0px 10px;\n    }\n    .second-inner-wrap header,.yuyue-first-inner-wrap header{\n      color:#5280e0;\n      font-size:13px;\n      padding-top:12px;\n      padding-left:10px;\n    }\n    .second-inner-wrap section,.yuyue-first-inner-wrap section{\n      padding:0px 0px 15px 0px;\n      //align-items:center;\n      //display:flex;\n      position:relative;\n      font-size:12px;\n      color:#999;\n    }\n    .second-inner-wrap section:after,.yuyue-first-inner-wrap section:after{\n      content:'';\n      clear:both;\n      display:block;\n    }\n    .second-inner-wrap section input,.yuyue-first-inner-wrap section input{\n      width:45%;\n      float:left;\n      display:block;\n      margin-top:16px;\n      margin-bottom:16px;\n      margin-right:5px;\n      margin-left:10px;\n      background-color:#eaeaea;\n      border:1px solid rgba(0,0,0,0);\n    }\n    .second-inner-wrap section div,.yuyue-first-inner-wrap section div{\n      width:50%;\n      float:left;\n    }\n    .yuyue-first-inner-wrap section input{\n      width:100%;\n      margin:0px;\n    }\n    .yuyue-first-inner-wrap section .first-input-code{\n      width:45%;\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n\n    .page-second footer{\n      padding:0px 10px 16px 10px;\n    }\n    .page-second footer button{\n      width:100%;\n      border-radius:6px;\n    }\n    .countDown{\n      color:#ff6600;\n    }\n    .second-inner-wrap .countDownWrapRepeat,\n    .second-inner-wrap .countDownWrap,\n    .first-countDownWrapRepeat,\n    .first-countDownWrap{\n      display:none;\n      font-size:14px;\n      margin-top:12px;\n    }\n    .yuyue-first footer{\n      padding:0px 10px 15px 10px;\n    }\n    .yuyue-first footer header{\n      font-size:15px;\n      color:" + color333 + ";\n      padding-bottom:15px;\n    }\n    .yuyue-first footer section{\n      display:block;\n      //align-items:center;\n      //justify-content:space-between;\n      //flex-wrap:wrap;\n      padding-bottom:20px;\n    }\n    .yuyue-first footer section:after{\n      display:block;\n      content:'';\n      clear:both;\n    }\n    .yuyue-first footer section span{\n      float:left;\n      display:inline-block;\n      width:23%;\n      margin:0px 1%;\n      background:#fff;\n      border-radius:6px;\n      padding:5px 10px;\n      margin-bottom:10px;\n      font-size:12px;\n      height:26px;\n      text-align:center;\n    }\n    .yuyue-first footer section span:first-child{\n      margin:0px 2% 0px 0px;\n    }\n    .yuyue-first footer section span:last-child{\n      margin:0px 0px 0px 2%;\n    }\n    .yuyue-first footer section span.hotFocus{\n      background-color:" + colorOrange + ";\n      color:#fff;\n    }\n    .yuyue-first footer .clue-btn{\n      width:100%;\n      border-radius:6px;\n    }\n    .input-clear{ \n      display: inline-block; width: 19px;\n      height:19px; background: #b4b4b4;\n      vertical-align: middle;position:absolute;\n          left: 92%;\n    top: 25px;\n      display:none;\n      border-radius:50%;\n    }\n    .input-clear:before{content:'';display: inline-block; width: 1px;position:absolute;top: 4px;\n    left: 9px;\n    height: 12px; background: #fff;line-height: 0;font-size:0;vertical-align: middle;\n      -webkit-transform: rotate(45deg) translate3d(0,0,0);\n      transform: rotate(45deg) translate3d(0,0,0);\n       -webkit-transform-origin: center center;\n      transform-origin: center center;\n    }\n    .input-clear:after{content:'';display:block;width: 1px;position:absolute;top: 4px;\n    left: 9px;\n    height: 12px; background: #fff;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n       -webkit-transform-origin: center center;\n      transform-origin: center center;\n  }\n\n  .input-clear-forcode{\n    left:37%;\n    top:33px;\n  }\n\n  .yuyue-first-inner-wrap section.first-actionSms,\n  .yuyue-first-inner-wrap section.first-countDownWrapRepeat,\n  .yuyue-first-inner-wrap section.first-countDownWrap{\n    \n    font-size:14px;\n    margin-top: 4px;\n    margin-left: 10px;\n    vertical-align:middle;\n    \n  }\n  .yuyue-first-inner-wrap section.first-actionSms, \n  .yuyue-first-inner-wrap section.first-countDownWrapRepeat,\n  .yuyue-first-inner-wrap section.first-countDownWrap .first-countDown {\n    color:#ff6600;\n    opacity:0.5;\n  }\n  .actionFirstSubmit{opacity:0.5}\n  .cancel-btn{\n    color:#b4b4b4;\n    font-size:12px;\n    position:absolute;\n    right:10px;\n    top:14px;\n    display:block;\n  }\n  .bodyNOScroll{\n    overflow:hidden\n  }\n   </style>\n  }\n  ";
	
	module.exports = Style;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4)))

/***/ },
/* 4 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** getCluebundle.js
 **/